import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { BigNumber } from '@ethersproject/bignumber';
import { Protocol } from '@uniswap/router-sdk';
import { TradeType } from '@uniswap/sdk-core';
import JSBI from 'jsbi';
import _ from 'lodash';
import FixedReverseHeap from 'mnemonist/fixed-reverse-heap';
import Queue from 'mnemonist/queue';
import { HAS_L1_FEE } from '../../../util';
import { CurrencyAmount } from '../../../util/amounts';
import { log } from '../../../util/log';
import { metric, MetricLoggerUnit } from '../../../util/metric';
import { routeAmountsToString, routeToString } from '../../../util/routes';
import { usdGasTokensByChain } from '../gas-models';
export function getBestSwapRoute(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
  return _getBestSwapRoute.apply(this, arguments);
}

function _getBestSwapRoute() {
  _getBestSwapRoute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(amount, percents, routesWithValidQuotes, routeType, chainId, routingConfig, gasModel) {
    var now, percentToQuotes, _iterator4, _step4, routeWithValidQuote, swapRoute, routeAmounts, totalAmount, missingAmount;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            now = Date.now(); // Build a map of percentage of the input to list of valid quotes.
            // Quotes can be null for a variety of reasons (not enough liquidity etc), so we drop them here too.

            percentToQuotes = {};
            _iterator4 = _createForOfIteratorHelper(routesWithValidQuotes);

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                routeWithValidQuote = _step4.value;

                if (!percentToQuotes[routeWithValidQuote.percent]) {
                  percentToQuotes[routeWithValidQuote.percent] = [];
                }

                percentToQuotes[routeWithValidQuote.percent].push(routeWithValidQuote);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }

            metric.putMetric('BuildRouteWithValidQuoteObjects', Date.now() - now, MetricLoggerUnit.Milliseconds); // Given all the valid quotes for each percentage find the optimal route.

            _context.next = 7;
            return getBestSwapRouteBy(routeType, percentToQuotes, percents, chainId, function (rq) {
              return rq.quoteAdjustedForGas;
            }, routingConfig, gasModel);

          case 7:
            swapRoute = _context.sent;

            if (swapRoute) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", null);

          case 10:
            // Due to potential loss of precision when taking percentages of the input it is possible that the sum of the amounts of each
            // route of our optimal quote may not add up exactly to exactIn or exactOut.
            //
            // We check this here, and if there is a mismatch
            // add the missing amount to a random route. The missing amount size should be neglible so the quote should still be highly accurate.
            routeAmounts = swapRoute.routes;
            totalAmount = _.reduce(routeAmounts, function (total, routeAmount) {
              return total.add(routeAmount.amount);
            }, CurrencyAmount.fromRawAmount(routeAmounts[0].amount.currency, 0));
            missingAmount = amount.subtract(totalAmount);

            if (missingAmount.greaterThan(0)) {
              log.info({
                missingAmount: missingAmount.quotient.toString()
              }, "Optimal route's amounts did not equal exactIn/exactOut total. Adding missing amount to last route in array.");
              routeAmounts[routeAmounts.length - 1].amount = routeAmounts[routeAmounts.length - 1].amount.add(missingAmount);
            }

            log.info({
              routes: routeAmountsToString(routeAmounts),
              numSplits: routeAmounts.length,
              amount: amount.toExact(),
              quote: swapRoute.quote.toExact(),
              quoteGasAdjusted: swapRoute.quoteGasAdjusted.toFixed(Math.min(swapRoute.quoteGasAdjusted.currency.decimals, 2)),
              estimatedGasUSD: swapRoute.estimatedGasUsedUSD.toFixed(Math.min(swapRoute.estimatedGasUsedUSD.currency.decimals, 2)),
              estimatedGasToken: swapRoute.estimatedGasUsedQuoteToken.toFixed(Math.min(swapRoute.estimatedGasUsedQuoteToken.currency.decimals, 2))
            }, "Found best swap route. ".concat(routeAmounts.length, " split."));
            return _context.abrupt("return", swapRoute);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getBestSwapRoute.apply(this, arguments);
}

export function getBestSwapRouteBy(_x8, _x9, _x10, _x11, _x12, _x13, _x14) {
  return _getBestSwapRouteBy.apply(this, arguments);
} // We do not allow pools to be re-used across split routes, as swapping through a pool changes the pools state.
// Given a list of used routes, this function finds the first route in the list of candidate routes that does not re-use an already used pool.

function _getBestSwapRouteBy() {
  _getBestSwapRouteBy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(routeType, percentToQuotes, percents, chainId, by, routingConfig, gasModel) {
    var _a, percentToSortedQuotes, quoteCompFn, sumFn, bestQuote, bestSwap, bestSwapsPerSplit, minSplits, maxSplits, forceCrossProtocol, _iterator5, _step5, routeWithQuote, queue, i, percent, splits, startedSplit, layer, _queue$dequeue, remainingPercent, curRoutes, percentIndex, special, _i, percentA, candidateRoutesA, routeWithQuoteA, remainingPercentNew, curRoutesNew, quotesNew, quoteNew, _gasCostL1QuoteToken, onlyV3Routes, gasCostL1, quoteAfterL1Adjust, postSplitNow, quoteGasAdjusted, estimatedGasUsed, usdToken, usdTokenDecimals, gasCostsL1ToL2, _onlyV3Routes, _gasCostsL1ToL, gasCostL1USD, gasCostL1QuoteToken, estimatedGasUsedUSDs, estimatedGasUsedUSD, decimalsDiff, estimatedGasUsedQuoteToken, quote, quoteGasAdjustedForL1, _quoteGasAdjustedForL, routeWithQuotes;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // Build a map of percentage to sorted list of quotes, with the biggest quote being first in the list.
            percentToSortedQuotes = _.mapValues(percentToQuotes, function (routeQuotes) {
              return routeQuotes.sort(function (routeQuoteA, routeQuoteB) {
                if (routeType == TradeType.EXACT_INPUT) {
                  return by(routeQuoteA).greaterThan(by(routeQuoteB)) ? -1 : 1;
                } else {
                  return by(routeQuoteA).lessThan(by(routeQuoteB)) ? -1 : 1;
                }
              });
            });
            quoteCompFn = routeType == TradeType.EXACT_INPUT ? function (a, b) {
              return a.greaterThan(b);
            } : function (a, b) {
              return a.lessThan(b);
            };

            sumFn = function sumFn(currencyAmounts) {
              var sum = currencyAmounts[0];

              for (var i = 1; i < currencyAmounts.length; i++) {
                sum = sum.add(currencyAmounts[i]);
              }

              return sum;
            };

            // Min-heap for tracking the 5 best swaps given some number of splits.
            bestSwapsPerSplit = new FixedReverseHeap(Array, function (a, b) {
              return quoteCompFn(a.quote, b.quote) ? -1 : 1;
            }, 3);
            minSplits = routingConfig.minSplits, maxSplits = routingConfig.maxSplits, forceCrossProtocol = routingConfig.forceCrossProtocol;

            if (!percentToSortedQuotes[100] || minSplits > 1 || forceCrossProtocol) {
              log.info({
                percentToSortedQuotes: _.mapValues(percentToSortedQuotes, function (p) {
                  return p.length;
                })
              }, 'Did not find a valid route without any splits. Continuing search anyway.');
            } else {
              bestQuote = by(percentToSortedQuotes[100][0]);
              bestSwap = [percentToSortedQuotes[100][0]];
              _iterator5 = _createForOfIteratorHelper(percentToSortedQuotes[100].slice(0, 5));

              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  routeWithQuote = _step5.value;
                  bestSwapsPerSplit.push({
                    quote: by(routeWithQuote),
                    routes: [routeWithQuote]
                  });
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            } // We do a BFS. Each additional node in a path represents us adding an additional split to the route.


            queue = new Queue(); // First we seed BFS queue with the best quotes for each percentage.
            // i.e. [best quote when sending 10% of amount, best quote when sending 20% of amount, ...]
            // We will explore the various combinations from each node.

            i = percents.length;

          case 8:
            if (!(i >= 0)) {
              _context2.next = 19;
              break;
            }

            percent = percents[i];

            if (percentToSortedQuotes[percent]) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("continue", 16);

          case 12:
            queue.enqueue({
              curRoutes: [percentToSortedQuotes[percent][0]],
              percentIndex: i,
              remainingPercent: 100 - percent,
              special: false
            });

            if (!(!percentToSortedQuotes[percent] || !percentToSortedQuotes[percent][1])) {
              _context2.next = 15;
              break;
            }

            return _context2.abrupt("continue", 16);

          case 15:
            queue.enqueue({
              curRoutes: [percentToSortedQuotes[percent][1]],
              percentIndex: i,
              remainingPercent: 100 - percent,
              special: true
            });

          case 16:
            i--;
            _context2.next = 8;
            break;

          case 19:
            splits = 1;
            startedSplit = Date.now();

          case 21:
            if (!(queue.size > 0)) {
              _context2.next = 77;
              break;
            }

            metric.putMetric("Split".concat(splits, "Done"), Date.now() - startedSplit, MetricLoggerUnit.Milliseconds);
            startedSplit = Date.now();
            log.info({
              top5: _.map(Array.from(bestSwapsPerSplit.consume()), function (q) {
                return "".concat(q.quote.toExact(), " (").concat(_(q.routes).map(function (r) {
                  return r.toString();
                }).join(', '), ")");
              }),
              onQueue: queue.size
            }, "Top 3 with ".concat(splits, " splits"));
            bestSwapsPerSplit.clear(); // Size of the queue at this point is the number of potential routes we are investigating for the given number of splits.

            layer = queue.size;
            splits++; // If we didn't improve our quote by adding another split, very unlikely to improve it by splitting more after that.

            if (!(splits >= 3 && bestSwap && bestSwap.length < splits - 1)) {
              _context2.next = 30;
              break;
            }

            return _context2.abrupt("break", 77);

          case 30:
            if (!(splits > maxSplits)) {
              _context2.next = 34;
              break;
            }

            log.info('Max splits reached. Stopping search.');
            metric.putMetric("MaxSplitsHitReached", 1, MetricLoggerUnit.Count);
            return _context2.abrupt("break", 77);

          case 34:
            if (!(layer > 0)) {
              _context2.next = 75;
              break;
            }

            layer--;
            _queue$dequeue = queue.dequeue(), remainingPercent = _queue$dequeue.remainingPercent, curRoutes = _queue$dequeue.curRoutes, percentIndex = _queue$dequeue.percentIndex, special = _queue$dequeue.special; // For all other percentages, add a new potential route.
            // E.g. if our current aggregated route if missing 50%, we will create new nodes and add to the queue for:
            // 50% + new 10% route, 50% + new 20% route, etc.

            _i = percentIndex;

          case 38:
            if (!(_i >= 0)) {
              _context2.next = 73;
              break;
            }

            percentA = percents[_i];

            if (!(percentA > remainingPercent)) {
              _context2.next = 42;
              break;
            }

            return _context2.abrupt("continue", 70);

          case 42:
            if (percentToSortedQuotes[percentA]) {
              _context2.next = 44;
              break;
            }

            return _context2.abrupt("continue", 70);

          case 44:
            candidateRoutesA = percentToSortedQuotes[percentA]; // Find the best route in the complimentary percentage that doesn't re-use a pool already
            // used in the current route. Re-using pools is not allowed as each swap through a pool changes its liquidity,
            // so it would make the quotes inaccurate.

            routeWithQuoteA = findFirstRouteNotUsingUsedPools(curRoutes, candidateRoutesA, forceCrossProtocol);

            if (routeWithQuoteA) {
              _context2.next = 48;
              break;
            }

            return _context2.abrupt("continue", 70);

          case 48:
            remainingPercentNew = remainingPercent - percentA;
            curRoutesNew = [].concat(_toConsumableArray(curRoutes), [routeWithQuoteA]); // If we've found a route combination that uses all 100%, and it has at least minSplits, update our best route.

            if (!(remainingPercentNew == 0 && splits >= minSplits)) {
              _context2.next = 69;
              break;
            }

            quotesNew = _.map(curRoutesNew, function (r) {
              return by(r);
            });
            quoteNew = sumFn(quotesNew);
            _gasCostL1QuoteToken = CurrencyAmount.fromRawAmount(quoteNew.currency, 0);

            if (!HAS_L1_FEE.includes(chainId)) {
              _context2.next = 64;
              break;
            }

            onlyV3Routes = curRoutesNew.every(function (route) {
              return route.protocol == Protocol.V3;
            });

            if (!(gasModel == undefined || !onlyV3Routes)) {
              _context2.next = 60;
              break;
            }

            throw new Error("Can't compute L1 gas fees.");

          case 60:
            _context2.next = 62;
            return gasModel.calculateL1GasFees(curRoutesNew);

          case 62:
            gasCostL1 = _context2.sent;
            _gasCostL1QuoteToken = gasCostL1.gasCostL1QuoteToken;

          case 64:
            quoteAfterL1Adjust = routeType == TradeType.EXACT_INPUT ? quoteNew.subtract(_gasCostL1QuoteToken) : quoteNew.add(_gasCostL1QuoteToken);
            bestSwapsPerSplit.push({
              quote: quoteAfterL1Adjust,
              routes: curRoutesNew
            });

            if (!bestQuote || quoteCompFn(quoteAfterL1Adjust, bestQuote)) {
              bestQuote = quoteAfterL1Adjust;
              bestSwap = curRoutesNew; // Temporary experiment.

              if (special) {
                metric.putMetric("BestSwapNotPickingBestForPercent", 1, MetricLoggerUnit.Count);
              }
            }

            _context2.next = 70;
            break;

          case 69:
            queue.enqueue({
              curRoutes: curRoutesNew,
              remainingPercent: remainingPercentNew,
              percentIndex: _i,
              special: special
            });

          case 70:
            _i--;
            _context2.next = 38;
            break;

          case 73:
            _context2.next = 34;
            break;

          case 75:
            _context2.next = 21;
            break;

          case 77:
            if (bestSwap) {
              _context2.next = 80;
              break;
            }

            log.info("Could not find a valid swap");
            return _context2.abrupt("return", undefined);

          case 80:
            postSplitNow = Date.now();
            quoteGasAdjusted = sumFn(_.map(bestSwap, function (routeWithValidQuote) {
              return routeWithValidQuote.quoteAdjustedForGas;
            })); // this calculates the base gas used
            // if on L1, its the estimated gas used based on hops and ticks across all the routes
            // if on L2, its the gas used on the L2 based on hops and ticks across all the routes

            estimatedGasUsed = _(bestSwap).map(function (routeWithValidQuote) {
              return routeWithValidQuote.gasEstimate;
            }).reduce(function (sum, routeWithValidQuote) {
              return sum.add(routeWithValidQuote);
            }, BigNumber.from(0));

            if (!(!usdGasTokensByChain[chainId] || !usdGasTokensByChain[chainId][0])) {
              _context2.next = 85;
              break;
            }

            throw new Error("Could not find a USD token for computing gas costs on ".concat(chainId));

          case 85:
            usdToken = usdGasTokensByChain[chainId][0];
            usdTokenDecimals = usdToken.decimals; // if on L2, calculate the L1 security fee

            gasCostsL1ToL2 = {
              gasUsedL1: BigNumber.from(0),
              gasCostL1USD: CurrencyAmount.fromRawAmount(usdToken, 0),
              gasCostL1QuoteToken: CurrencyAmount.fromRawAmount( // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
              (_a = bestSwap[0]) === null || _a === void 0 ? void 0 : _a.quoteToken, 0)
            }; // If swapping on an L2 that includes a L1 security fee, calculate the fee and include it in the gas adjusted quotes

            if (!HAS_L1_FEE.includes(chainId)) {
              _context2.next = 97;
              break;
            }

            // ensure the gasModel exists and that the swap route is a v3 only route
            _onlyV3Routes = bestSwap.every(function (route) {
              return route.protocol == Protocol.V3;
            });

            if (!(gasModel == undefined || !_onlyV3Routes)) {
              _context2.next = 94;
              break;
            }

            throw new Error("Can't compute L1 gas fees.");

          case 94:
            _context2.next = 96;
            return gasModel.calculateL1GasFees(bestSwap);

          case 96:
            gasCostsL1ToL2 = _context2.sent;

          case 97:
            _gasCostsL1ToL = gasCostsL1ToL2, gasCostL1USD = _gasCostsL1ToL.gasCostL1USD, gasCostL1QuoteToken = _gasCostsL1ToL.gasCostL1QuoteToken; // For each gas estimate, normalize decimals to that of the chosen usd token.

            estimatedGasUsedUSDs = _(bestSwap).map(function (routeWithValidQuote) {
              // TODO: will error if gasToken has decimals greater than usdToken
              var decimalsDiff = usdTokenDecimals - routeWithValidQuote.gasCostInUSD.currency.decimals;

              if (decimalsDiff == 0) {
                return CurrencyAmount.fromRawAmount(usdToken, routeWithValidQuote.gasCostInUSD.quotient);
              }

              return CurrencyAmount.fromRawAmount(usdToken, JSBI.multiply(routeWithValidQuote.gasCostInUSD.quotient, JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(decimalsDiff))));
            }).value();
            estimatedGasUsedUSD = sumFn(estimatedGasUsedUSDs); // if they are different usd pools, convert to the usdToken

            if (estimatedGasUsedUSD.currency != gasCostL1USD.currency) {
              decimalsDiff = usdTokenDecimals - gasCostL1USD.currency.decimals;
              estimatedGasUsedUSD = estimatedGasUsedUSD.add(CurrencyAmount.fromRawAmount(usdToken, JSBI.multiply(gasCostL1USD.quotient, JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(decimalsDiff)))));
            } else {
              estimatedGasUsedUSD = estimatedGasUsedUSD.add(gasCostL1USD);
            }

            log.info({
              estimatedGasUsedUSD: estimatedGasUsedUSD.toExact(),
              normalizedUsdToken: usdToken,
              routeUSDGasEstimates: _.map(bestSwap, function (b) {
                return "".concat(b.percent, "% ").concat(routeToString(b.route), " ").concat(b.gasCostInUSD.toExact());
              }),
              flatL1GasCostUSD: gasCostL1USD.toExact()
            }, 'USD gas estimates of best route');
            estimatedGasUsedQuoteToken = sumFn(_.map(bestSwap, function (routeWithValidQuote) {
              return routeWithValidQuote.gasCostInToken;
            })).add(gasCostL1QuoteToken);
            quote = sumFn(_.map(bestSwap, function (routeWithValidQuote) {
              return routeWithValidQuote.quote;
            })); // Adjust the quoteGasAdjusted for the l1 fee

            if (routeType == TradeType.EXACT_INPUT) {
              quoteGasAdjustedForL1 = quoteGasAdjusted.subtract(gasCostL1QuoteToken);
              quoteGasAdjusted = quoteGasAdjustedForL1;
            } else {
              _quoteGasAdjustedForL = quoteGasAdjusted.add(gasCostL1QuoteToken);
              quoteGasAdjusted = _quoteGasAdjustedForL;
            }

            routeWithQuotes = bestSwap.sort(function (routeAmountA, routeAmountB) {
              return routeAmountB.amount.greaterThan(routeAmountA.amount) ? 1 : -1;
            });
            metric.putMetric('PostSplitDone', Date.now() - postSplitNow, MetricLoggerUnit.Milliseconds);
            return _context2.abrupt("return", {
              quote: quote,
              quoteGasAdjusted: quoteGasAdjusted,
              estimatedGasUsed: estimatedGasUsed,
              estimatedGasUsedUSD: estimatedGasUsedUSD,
              estimatedGasUsedQuoteToken: estimatedGasUsedQuoteToken,
              routes: routeWithQuotes
            });

          case 108:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getBestSwapRouteBy.apply(this, arguments);
}

var findFirstRouteNotUsingUsedPools = function findFirstRouteNotUsingUsedPools(usedRoutes, candidateRouteQuotes, forceCrossProtocol) {
  var poolAddressSet = new Set();

  var usedPoolAddresses = _(usedRoutes).flatMap(function (r) {
    return r.poolAddresses;
  }).value();

  var _iterator = _createForOfIteratorHelper(usedPoolAddresses),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var poolAddress = _step.value;
      poolAddressSet.add(poolAddress);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var protocolsSet = new Set();

  var usedProtocols = _(usedRoutes).flatMap(function (r) {
    return r.protocol;
  }).uniq().value();

  var _iterator2 = _createForOfIteratorHelper(usedProtocols),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var protocol = _step2.value;
      protocolsSet.add(protocol);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _iterator3 = _createForOfIteratorHelper(candidateRouteQuotes),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var routeQuote = _step3.value;
      var poolAddresses = routeQuote.poolAddresses,
          _protocol = routeQuote.protocol;

      if (poolAddresses.some(function (poolAddress) {
        return poolAddressSet.has(poolAddress);
      })) {
        continue;
      } // This code is just for debugging. Allows us to force a cross-protocol split route by skipping
      // consideration of routes that come from the same protocol as a used route.


      var needToForce = forceCrossProtocol && protocolsSet.size == 1;

      if (needToForce && protocolsSet.has(_protocol)) {
        continue;
      }

      return routeQuote;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return null;
};